import styles from "./TokenCard.module.css"
import { convertLargeCurrency } from "../../../../../utils/general";
import { AiOutlineArrowDown, AiOutlineArrowUp} from "react-icons/ai"
const TokenCard = (props) => {
  const { symbol, name, image, idx } = props
  
  function getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min;
  }
  
  const TVL = getRandomArbitrary(1000000, 1000000000)
  const VOLUME = getRandomArbitrary(0, 100000000)
  const PRICE_CHANGE = (Math.random() * (-5.00 - 1.00 + 1.00) + 1.00).toFixed(2)
  const PRICE = getRandomArbitrary(0, 30000)


  const priceChangeStyle = PRICE_CHANGE <= 0 ? styles.color_red : styles.color_green
  const priceChangeArrow = PRICE_CHANGE <= 0 ? <AiOutlineArrowDown color="red" size={15} /> :
  <AiOutlineArrowUp color="green" size={15} />

  
  return (
    <div className={styles.token_info_content}>
      <span className={`${styles.token_number} ${styles.color_white}`}>{ idx + 1}</span>
    <div className={`${styles.token_name} ${styles.token_name_container}`}>
        <img src={image} width="25px"alt=""/>
        <span>{name}</span>
        <span className={styles.symbol}>({symbol})</span>
    </div>
      <span className={`${styles.title_price} ${styles.color_white}`}> ${ convertLargeCurrency(PRICE)}</span>
      <div className={`${styles.title_price_change} ${priceChangeStyle}`}>{ priceChangeArrow}{ PRICE_CHANGE}</div>
      <span className={`${styles.title_volume} ${styles.color_white}`}> { convertLargeCurrency(VOLUME)}</span>
      <span className={`${styles.title_tvl} ${styles.color_white}`}>${ convertLargeCurrency(TVL)}</span>
    
</div>
  )
}

export default TokenCard